module.exports = __webpack_public_path__ + "static/media/sj1.6496addf.jpg";